import { ObjectListRequestType } from '../ObjectListResponseTypes'
import { ObjectListType } from '../ObjectListTypes'

export interface Document {
  id: number
  name: string
  date: string
  uploadedBy: string
  size: number
  version: number
  type: string
  category: string
  extension: string
  comment: string
}

export interface DocumentList extends ObjectListType {
  documents: Document[]
}

export interface DocumentRequest extends ObjectListRequestType {}

export const isDocumentListType = (documentList: any): documentList is DocumentList => {
  if (documentList === undefined) {
    return false
  }
  return 'documents' in documentList
}

export const isDocumentRequest = (request: any): request is DocumentRequest => {
  if (request === undefined) {
    return false
  }
  return true
  //return 'statusid' in request
}
